/**
 * Widgets mobile Splide – always initializes and stays initialized (live match or not).
 * Re-initializes on heroUpdated / fixturesUpdated so the widget carousel keeps working.
 */
( function () {
	const WIDGETS_SELECTOR = '#splide-widgets-mobile';

	function initWidgetsSplide() {
		const el = document.querySelector( WIDGETS_SELECTOR );
		
		if ( ! el ) {
			return;
		}

		// Check if _s is available
		if ( typeof window._s === 'undefined' ) {
			return;
		}

		// Destroy existing instance so we don't double-mount
		if ( el.splideInstance ) {
			try {
				el.splideInstance.destroy();
				el.splideInstance = null;
			} catch ( err ) {
				// ignore
			}
		}

		let config = {};
		try {
			let raw = el.getAttribute( 'data-splide' );
			if ( raw ) {
				// Decode HTML entities if present
				const txt = document.createElement( 'textarea' );
				txt.innerHTML = raw;
				raw = txt.value;
				
				config = JSON.parse( raw );
			}
		} catch ( e ) {
			// Silent fail
		}

		try {
			const splideInstance = new Splide( el, config );
			el.splideInstance = splideInstance;

			splideInstance.on( 'mounted', () => {
				el.classList.add( 'is-initialized' );
			} );

			splideInstance.mount();

			if ( config.refresh_on_resize && typeof window.debounce !== 'undefined' ) {
				window.addEventListener( 'resize', window.debounce( () => {
					splideInstance.refresh();
				}, 100 ) );
			}
		} catch ( err ) {
			// Silent fail
		}
	}

	function runWhenSplideReady() {
		if ( typeof window.splideWhenReady === 'function' ) {
			window.splideWhenReady( initWidgetsSplide );
		} else if ( typeof window.Splide !== 'undefined' ) {
			initWidgetsSplide();
		} else {
			// Fallback if util not loaded
			const url = window.SPLIDE_CDN_URL || 'https://cdn.jsdelivr.net/npm/@splidejs/splide/dist/js/splide.min.js';
			const script = document.createElement( 'script' );
			script.src = url;
			script.onload = initWidgetsSplide;
			document.head.appendChild( script );
		}
	}

	// Use native DOMContentLoaded and multiple init attempts
	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', () => {
			runWhenSplideReady();
		} );
	} else {
		runWhenSplideReady();
	}

	// Also use window._s.ready if available
	if ( typeof window._s !== 'undefined' ) {
		window._s( document ).ready( () => {
			// Only init if not already initialized
			const el = document.querySelector( WIDGETS_SELECTOR );
			if ( el && ! el.splideInstance ) {
				runWhenSplideReady();
			}
		} );
	}

	// Keep widget splide initialized after hero/match updates (live or not)
	[ 'fixturesUpdated', 'heroUpdated' ].forEach( ( eventName ) => {
		document.addEventListener( eventName, () => {
			// Small delay so new DOM is in place
			setTimeout( runWhenSplideReady, 100 );
		} );
	} );
} )();
